import querySerializer from 'query-string'
import Cookies from 'js-cookie'
import config from 'config'
import { redirect } from 'redux-first-router'
import { PUBLIC_PAGES } from 'actions/auth'
import { ADD_RETURN_TO } from 'constants/action_types'
import {
  LOGIN_PAGE,
  MAIN_PAGE,
  SETTINGS_BILLING_PAGE,
  SEARCH_PAGE,
  LOGOUT_PAGE,
} from 'constants/pages'
import debug from 'util/debug'
import { emptyObj } from 'util/objects'
import storage from 'util/storage'
import {
  selectIsBillingAccountActive,
  selectIsBillingDataLoaded,
} from 'ducks/billing/selectors'
import {
  selectCurrentSortOrder,
  isBoostrappedSelector,
  oauthTokenSelector,
} from 'selectors/app'
import {
  selectCurrentUser,
  selectCurrentUserIsOwner,
} from 'ducks/currentUser/selectors'
import { DEFAULT_SORT_ORDER } from 'constants/defaults'
import { V2_SIGNUP_PAGE, SIGNUP_PAGE } from 'subapps/onboarding/pages'
import { isMobile } from 'util/browser'

const isAllowed = (type, token) => {
  if (token) return true
  if (PUBLIC_PAGES.includes(type)) return true
  return false
}

// Auth filtering: onBeforeChange fires before going to a new route, and you
// can redirect if certian conditions aren't met.
export default {
  querySerializer,
  onBeforeChange: (dispatch, getState, { action: { type, payload, meta } }) => {
    const state = getState()
    const token = oauthTokenSelector(state)
    const currentSortOrder = selectCurrentSortOrder(state)

    try {
      const { host } = window.location
      if (
        !config.isAlpha &&
        isMobile() &&
        !host.match('mobile.groovehq') &&
        !host.match('mobile-staging.groovehq')
      ) {
        let href
        if (host.match('staging.groovehq')) {
          href = window.location.href.replace(
            /[\w-]+.staging.groovehq/,
            'mobile-staging.groovehq'
          )
        } else {
          href = window.location.href.replace(
            /[\w-]+.groovehq/,
            'mobile.groovehq'
          )
        }
        window.location.href = href
      }
    } catch (e) {
      bugsnagClient.notify(e)
    }

    if (!isAllowed(type, token)) {
      // redirect to original url after login is successful
      dispatch({
        type: ADD_RETURN_TO,
        meta,
        payload: {
          returnTo: {
            type,
            payload,
          },
        },
      })
      return dispatch(redirect({ type: LOGIN_PAGE }))
    }

    // FIXME: Right now non-owner users will go into an infinite loop when the
    // account is inactive. Waiting on some feedback from Nick around how to resolve
    // this issue
    if (
      isBoostrappedSelector(state) &&
      type === SETTINGS_BILLING_PAGE &&
      selectCurrentUser(state) !== emptyObj &&
      !selectCurrentUserIsOwner(state)
    ) {
      return dispatch(
        redirect({
          type: MAIN_PAGE,
        })
      )
    }

    // If your account or inbox is not active, redirect to billing page
    if (
      selectIsBillingDataLoaded(state) &&
      type !== SETTINGS_BILLING_PAGE &&
      type !== LOGOUT_PAGE &&
      !selectIsBillingAccountActive(state)
    ) {
      return dispatch(redirect({ type: SETTINGS_BILLING_PAGE }))
    }

    // If the requested search has no sort option, redirect to ?sort=newest
    if (type === SEARCH_PAGE) {
      // RFR puts query string here, if its in the URL.
      const { current } = meta.location
      const { query: { sort } = {} } = current
      // Will be populated by us below, if we redirected already.
      const { query: { sort: sortFromRedirect } = {} } = meta

      if (!sort && !sortFromRedirect) {
        debug('redirecting to search page with default sort option')

        return dispatch(
          redirect({
            type: SEARCH_PAGE,
            payload,
            meta: {
              ...meta,
              query: {
                ...current.query,
                sort: currentSortOrder || DEFAULT_SORT_ORDER,
              },
            },
          })
        )
      }
    }
    // If we are on a signup page, look to see if the layout variant is set and store.
    if (type === SIGNUP_PAGE || type === V2_SIGNUP_PAGE) {
      // Clean up existing storage
      storage.cleanupAppStorage()

      const { current } = meta.location
      const { query: { lv: layoutVariant } = {} } = current
      if (layoutVariant !== undefined) {
        Cookies.set('onboardingLayoutVariant', parseInt(layoutVariant, 10), {
          domain: `.${config.appDomain}`,
          expires: 7,
        })
      }
    }

    return true
  },
}
